import { render, staticRenderFns } from "./CreateContentDevolution.vue?vue&type=template&id=19699356&scoped=true"
import script from "./CreateContentDevolution.vue?vue&type=script&lang=js"
export * from "./CreateContentDevolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19699356",
  null
  
)

export default component.exports